import templateUrl from './user-ingredient-form.html';

export default {
  templateUrl,
  transclude: {
    actionButtons: '?actionButtons'
  },
  bindings: {
    ingredient: '<',
    dialogTitle: '@',
    submitTitle: '@',
    ingredientChanged: '&'
  },
  controller: class UserIngredientFormComponent {
    constructor(EventEmitter) {
      'ngInject';

      Object.assign(this, { EventEmitter });
    }

    onSubmit() {
      this.ingredientChanged(
        this.EventEmitter({
          ingredient: this.ingredient
        })
      );
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/admin/user-ingredients/user-ingredient-form/user-ingredient-form.component.js